// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pagination-box[data-v-6b096782] {\n  height: 40px;\n  border-radius: 8px;\n  min-width: 140px;\n  background-color: var(--v-primary-base);\n}\n.pagination-box.hidden[data-v-6b096782] {\n  visibility: hidden;\n}", ""]);
// Exports
module.exports = exports;
